import { ReactNode } from "react";
import {
  TextBody,
  TextSecondary,
} from "../../components/DesignSystem/DesignSystemText";
import VerifiedIcon from "./VerifiedIcon";

export interface DetailsSectionProps {
  title: string;
  children: ReactNode;
  helperText?: string;
  action?: { text: string; onClick: () => void };
  isVerified?: boolean;
}

const DetailsSection = ({
  title,
  helperText,
  action,
  children,
  isVerified,
}: DetailsSectionProps) => {
  return children ? (
    <section>
      <header className="flex mb-1 gap-x-1">
        <div className="flex items-center">
          <TextBody className="!font-bold">{title}</TextBody>
          {isVerified && (
            <span className="ml-[4rem]">
              <VerifiedIcon />
            </span>
          )}
        </div>

        <TextSecondary>{helperText}</TextSecondary>
        <div onClick={action?.onClick}>
          <TextBody className="!font-bold !text-[#6ec1ac] cursor-pointer">
            {action?.text}
          </TextBody>
        </div>
      </header>
      <TextSecondary>{children}</TextSecondary>
    </section>
  ) : (
    <></>
  );
};

export default DetailsSection;
